import CallServices from "../../../services/CallServices";
import { MakeCallDto } from "../../../dtos/Call/MakeCallDto";
import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { EventBusEventsEnum } from "../../../enums/EventBusEventsEnum";
import EventBus from "../../../EventBus";
import { CustomSnackbarTypes } from "../CustomSnackBar";
import CallIcon from "@mui/icons-material/Call";
import { UserType } from "../../../enums/common";
import { maskPhoneNumber } from "../../../utils/PhoneNumberUtils";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { setMakeCall } from "../../../store/reducers/callSlice";

const callServices = new CallServices();

export enum CallPurposeEnum {
  HC_SUPPORT = "HC Support",
  ALLOCATION = "Allocation",
  SALES = "Sales",
  CX_SUPPORT = "Cx Support",
  TRACKING = "Tracking",
  ONBOARDING = "Onboarding",
  PRO_ACTIVE_OPS = "Pro Active Ops",
  SOS_TICKET = "SOS Ticket"
}
interface InputProps { toPhoneNumber: string; userType: string; heading?: string; referenceId?: number; referenceModelName?: string; disableMask?: boolean; }

function CallButton(props: InputProps) {
  const [openCallingDialog, setOpenCallingDialog] = useState(false);
  const [holdApiCall, setHoldApiCall] = useState(false);
  const [dialogMessage, setDialogMessage] = useState<string>('');

  const userDetails = useAppSelector((state) => state.userDetails.value);
  const makeCallValue = useAppSelector((state) => state.makeCall.makeCall);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleOnClick = () => {
    if (!userDetails?.adminUser?.mobile) {
      navigate(`/AdminUsers/${userDetails?.adminUser?.id}`);
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Phone No required",
        type: CustomSnackbarTypes.ERROR,
      });
      return;
    }

    setOpenCallingDialog(true);
  };

  const handlePurposeSelect = (purpose: string) => {
    if (!makeCallValue || holdApiCall) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Already a call in progress. Please wait.",
        type: CustomSnackbarTypes.WARNING,
      });
      return;
    }

    setDialogMessage(`Connecting your call...`);
    const payload: MakeCallDto = {
      from: userDetails?.adminUser?.mobile!,
      to: props.toPhoneNumber,
      userType: props.userType,
      purpose,
      referenceId: props.referenceId,
      referenceModelName: props.referenceModelName,
      initiatedBy: userDetails?.adminUser?.id!,
      initiatedByType: "ADMIN",
    };

    setHoldApiCall(true);

    callServices
      .makeCall(payload)
      .then(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Please wait while we connect your call.",
          type: CustomSnackbarTypes.SUCCESS,
        });

        dispatch(setMakeCall({ makeCall: false }));

        setTimeout(() => {
          setHoldApiCall(false);
          dispatch(setMakeCall({ makeCall: true }));
        }, 10000);
      })
      .catch(() => {
        setHoldApiCall(false);
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Failed to initiate call",
          type: CustomSnackbarTypes.ERROR,
        });
      });
  };

  return (
    <div>
      {props?.heading && (
        <Typography fontSize="0.75em" color="#525252" mb={0.2}>
          {props.heading}
        </Typography>
      )}

      {!!props.toPhoneNumber && (
        <div className="displayFlex">
          <div>{props.userType === UserType.COOK && !props.disableMask ? maskPhoneNumber(props.toPhoneNumber) : props.toPhoneNumber}</div>
          <Box position="relative">
            <CallIcon
              color="success"
              className="cursorPointer"
              onClick={(e) => {
                e.stopPropagation();
                handleOnClick();
              }}
              sx={{ position: "absolute" }}
            />
          </Box>
        </div>
      )}

      <Dialog open={openCallingDialog} onClose={() => setOpenCallingDialog(false)}   onClick={(e) => e.stopPropagation()} 
>
        <DialogContent sx={{ textAlign: "center", minWidth: 300 }}>
        <>
          {dialogMessage ? (
            <Typography>{dialogMessage}</Typography>
          ) : (
            <>
              <Typography mb={2}>Select Call Purpose</Typography>

              <Box display="flex" flexWrap="wrap" gap={1} justifyContent="center">
                {Object.values(CallPurposeEnum).map((purpose) => (
                  <Button
                    key={purpose}
                    variant="outlined"
                    color="success"
                    disabled={holdApiCall}
                    onClick={() => handlePurposeSelect(purpose)}
                    sx={{ minWidth: 120 }}
                  >
                    {purpose}
                  </Button>
                ))}
              </Box>
            </>
          )}
        </>

        </DialogContent>

        <DialogActions>
          <Button onClick={() => {
            setOpenCallingDialog(false)
            setDialogMessage('')
          }}
          color="success"
          variant="contained">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CallButton;
